import { Component, OnInit } from '@angular/core';
import { VariablesService } from 'src/app/globalService/variables.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from 'src/app/shared/authorizeService/authorize.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { GenericResult } from 'src/app/globalClass/generic-class.model';
import { CategoriaService } from 'src/app/parametricas/categorias/shared/categoria.service';
import { FilesService } from 'src/app/shared/files.service';

@Component({
  selector: 'app-registro-cliente',
  templateUrl: './registro-cliente.component.html',
  styleUrls: ['./registro-cliente.component.css']
})
export class RegistroClienteComponent implements OnInit {
  token:string = "";
  rl:boolean = false;
  nat:boolean = false;
  ad:boolean = false;
  listTypeDocumnet:any[]=[];
  siNoAdmin:boolean = false;
  minimoCaracteres: number=8;
  isLoader: boolean = false;
  messageLoader = "Cargando...";

  constructor(
    private _variables:VariablesService,
    private _activateRoute:ActivatedRoute,
    private _authorizeService:AuthorizeService,
    private _toastr:ToastrService,
    private _categoriaServices:CategoriaService,
    //private _cryptoJs:CryptojsService,
    private _router:Router,
    private _fb:FormBuilder,
    private _fileService: FilesService
    //private _userService:UsuarioService,
  ) {
    //debugger;
    this._activateRoute.params.subscribe(params=>{
      //debugger;
      this.loadData();
      this.token = params["to"];
      this.validateToken(this.token);
      //this.nat = true;
   });
  }

  async loadData(){
    await this.loadVariables();
    await this._categoriaServices.getCategoriaByIdTipo (1).then(r => {
      this.listTypeDocumnet = r;
    });
  }

  async loadVariables() {
    await this._variables.getVariables().then(
      r => {
        this.minimoCaracteres = this._variables.data.minimoCaracteresPass;
      }
    );
  }

  loadInfo(usuario:any){
    switch (usuario.idSegTipoPersona) {
      case 3:
        this.formPersonaJuridica.patchValue({
          idUsuario:usuario.idSegUsuario,
          nitEmpresa:usuario.nit,
          nombreEmpresa:usuario.nombreEmpresa,
          correoElectronico:usuario.correoElectronico,
          tipoDocumento:usuario.idTipoDocumento,
          numeroDocumento:usuario.numeroDocumento,
          nombres:usuario.nombre,
          primerApellido:usuario.apellido1,
          segundoApellido:usuario.apellido2,
          telefono:usuario.telefono,
          cargo:usuario.cargo
        });
        break;
      case 7:
        this.formPersonaNatural.patchValue({
          idUsuario:usuario.idSegUsuario,
          correoElectronico:usuario.correoElectronico,
          numeroDocumento:usuario.numeroDocumento,
          nombres:usuario.nombre,
          tipoDocumento:usuario.idTipoDocumento,
          primerApellido:usuario.apellido1,
          segundoApellido:usuario.apellido2,
          telefono:usuario.telefono
        });
        break;
      case 4:
        this.formAdministradorDesignado.patchValue({
          idUsuario:usuario.idSegUsuario,
          nitEmpresa:usuario.nit,
          nombreEmpresa:usuario.nombreEmpresa,
          correoElectronico:usuario.correoElectronico,
          tipoDocumento:usuario.idTipoDocumento,
          numeroDocumento:usuario.numeroDocumento,
          nombres:usuario.nombre,
          primerApellido:usuario.apellido1,
          segundoApellido:usuario.apellido2,
          telefono:usuario.telefono,
          cargo:usuario.cargo
        });
        break;
    }

    
  }

  formPersonaJuridica:FormGroup = this._fb.group({
    idUsuario:[null,Validators.required],
    nitEmpresa:[null,Validators.required],
    nombreEmpresa:[null,Validators.required],
    correoElectronico:[null,Validators.required],
    tipoDocumento:[null,Validators.required],
    numeroDocumento:[null,Validators.required],
    nombres:[null,Validators.required],
    primerApellido:[null,Validators.required],
    segundoApellido:[null],
    telefono:[null,Validators.required],
    cargo:[null,Validators.required],
    token: this.token,
    contrasena1: ["", [Validators.required, Validators.minLength(this.minimoCaracteres), this.validatePassword]],
    contrasena2: ["", [this.equalsTo('contrasena1'), Validators.required]]
  });

  formAdministradorDesignado:FormGroup = this._fb.group({
    idUsuario:[null,Validators.required],
    nitEmpresa:[null],
    nombreEmpresa:[null],
    correoElectronico:[null,Validators.required],
    tipoDocumento:[null,Validators.required],
    numeroDocumento:[null,Validators.required],
    nombres:[null,Validators.required],
    primerApellido:[null,Validators.required],
    segundoApellido:[null],
    telefono:[null,Validators.required],
    cargo:[null],
    token: this.token,
    contrasena1: ["", [Validators.required, Validators.minLength(this.minimoCaracteres), this.validatePassword]],
    contrasena2: ["", [this.equalsTo('contrasena1'), Validators.required]]
  });


  formPersonaNatural:FormGroup = this._fb.group({
    idUsuario:[null,Validators.required],
    correoElectronico:[null,Validators.required],
    tipoDocumento:[null,Validators.required],
    numeroDocumento:[null,Validators.required],
    nombres:[null,Validators.required],
    primerApellido:[null,Validators.required],
    segundoApellido:[null],
    telefono:[null,Validators.required],
    token: this.token,
    contrasena1: ["", [Validators.required, Validators.minLength(this.minimoCaracteres), this.validatePassword]],
    contrasena2: ["", [this.equalsTo('contrasena1'), Validators.required]]
  });

  ngOnInit() {
  }

openAdministradorPortalModal(){
  
  if(this.formPersonaJuridica.valid){
    if($('#chckTerminosJuridica').prop('checked')){
      $("#AdministradorPortalModal").modal('show');
    }else{
      this._toastr.warning("Para continuar debe Aceptar los Términos y Condiciones de Uso del Portal Web.")
    }
  }else{
    this._toastr.warning("Por favor diligencie la información solicitada por el formulario.")
  }
}

openPersonaNaturalModal(){
  console.log(this.formPersonaNatural);
  if(this.formPersonaNatural.valid){
    if($('#chckTerminosNatural').prop('checked')){
      $("#PersonaNaturalModal").modal('show');
    }else{
      this._toastr.warning("Para continuar debe Aceptar los Términos y Condiciones de Uso del Portal Web.")
    }
  }else{
    this._toastr.warning("Por favor diligencie la información solicitada por el formulario.")
  }
}

openModalAdministradorAsignadoPortalModal(){
  if(this.formAdministradorDesignado.valid){
    if($('#chckTerminosAdministradorAsignado').prop('checked')){
      $("#AdministradorAsignado").modal('show');
    }else{
      this._toastr.warning("Para continuar debe Aceptar los Términos y Condiciones de Uso del Portal Web.")
    }
  }else{
    this._toastr.warning("Por favor diligencie la información solicitada por el formulario.")
  }
}

SiNoAdmin(event){
  //debugger;
  let val = event.target.value;
  this.siNoAdmin = (val == 'Si');
}

insertarPersonaJuridica(){
  let tempForm = {
    token: this.token,
    contrasena1: this.formPersonaJuridica.get("contrasena1").value,
    contrasena2: this.formPersonaJuridica.get("contrasena2").value
  }
  this.registerPassWord(tempForm);
}

terminosyCondiciones(){
  this.isLoader = true;
  this._authorizeService.getTerminosYCondiciones().then(
    (r: GenericResult) => {
      let fileName = 'TERMINOS Y CONDICIONES DE USO DE PORTAL WEB (002).pdf'
      this._fileService.downloadFile(r, fileName);
      this.isLoader = false;
    }
  );
}


registerPassWord(tempForm:any){
  //debugger;
  this._authorizeService.registerPassword(tempForm).then(
    (r: GenericResult) => {
      if (r.error) {
        this._toastr.error("A ocurrido un error mientras realizabamos el proceso por favor vuelve a intentarlo mas tarde")
      } else {
        if (r.result == "Ok") {
          this._toastr.info("Tu contraseña se ha asignado con éxito, ingresa con tu usuario y contraseña");
          $("#AdministradorPortalModal").modal('hide');
          $("#PersonaNaturalModal").modal('hide');
          $("#AdministradorAsignado").modal('hide');
          this._router.navigate(["/login"]);
        } else {
          if (r.result == "containNombre") {
            this._toastr.info("Tu contraseña no puede contener tu nombre");
            this.resetForm();
          } else if (r.result == "containDocumento") {
            this._toastr.info("Tu contraseña no puede contener tu número de documento");
            this.resetForm();
          } else if (r.result == "containEmail") {
            this._toastr.info("Tu contraseña no puede contener tu correo electrónico");
            this.resetForm();
          } else if (r.result == "oldPass") {
            this._toastr.info("Tu contraseña no puede ser igual a ninguna de tus ultimas 13 contraseñas usadas para el ingreso al Portal WtW.");
            this.resetForm();
          }else if(r.result == "tokenInvalid"){
            this._toastr.error("Por favor solicite un token valido para realizar la asignación de su contraseña.");
            this._router.navigate(["/login"]);
          }
          $("#AdministradorPortalModal").modal('hide');
          $("#PersonaNaturalModal").modal('hide');
          $("#AdministradorAsignado").modal('hide');
        }
      }
    }
  )
}


insertarAdministradorDesignado(){
  let values = this.formAdministradorDesignado.value;

  let tempForm = {
    token: this.token,
    contrasena1: this.formAdministradorDesignado.get("contrasena1").value,
    contrasena2: this.formAdministradorDesignado.get("contrasena2").value
  }
  this.registerPassWord(tempForm);
}

resetForm(){
    this.formAdministradorDesignado.patchValue({
      contrasena1:"",
      contrasena2:""
    });
    this.formPersonaJuridica.patchValue({
      contrasena1:"",
      contrasena2:""
    });
    this.formPersonaNatural.patchValue({
      contrasena1:"",
      contrasena2:""
    });
}


insertarPersonaNatural(){
  let tempForm = {
    token: this.token,
    contrasena1: this.formPersonaNatural.get("contrasena1").value,
    contrasena2: this.formPersonaNatural.get("contrasena2").value
  }
  this.registerPassWord(tempForm);
}


validateToken(tkn:string){
  this._authorizeService.validateTokenRegisterPerson(tkn).then(
    (r:GenericResult)=>{
      if(r.error){
        this._toastr.warning("Usted esta intentado ingresar a esta area de forma invalida");
        this._router.navigate(["/login"]);
      }else{
        if(r.result == "TokenTimeLose"){
          this._toastr.warning("El tiempo para realizar el registro  ha caducado, por favor contacte con su administrador de soporte, para obtener un nuevo token");
          this._router.navigate(["/login"]);
        }else{
          this.rl = (r.result.idSegTipoPersona == 3);
          this.nat = (r.result.idSegTipoPersona == 7);
          this.ad = (r.result.idSegTipoPersona == 4);
          this.loadInfo(r.result);
          this._toastr.success("Registre su contraseña para completar su acceso al portal.");
        }
      } 
    }
    ,error=>{
      this._toastr.warning("Por favor verifique el estado de su conexión y vuelva a intentarlo.");
      this._router.navigate(["/login"]);
    } 
  );
}


private validatePassword(control: AbstractControl) {
  let hasNumber = /\d/.test(control.value);
  let hasUpper = /[A-Z]/.test(control.value);
  let hasLower = /[a-z]/.test(control.value);
  let hasEspecialCharacter = /[`~!@#$%^&*()_°¬|+\-=?;:'",.<>\{\}\[\]\\\/]/gi.test(control.value);
  let error = null;
  if (!hasNumber) {
    error = { ...error, notnumber: 'su contraseña debe contener al menos un carácter númerico' };
  }
  if (!hasUpper) {
    error = { ...error, mayuscula: 'Su contraseña debe contener al menos una letra mayúscula' };
  }
  if (!hasLower) {
    error = { ...error, minuscula: 'Su contraseña debe contener al menos una letra minúscula' };
  }
  if (!hasEspecialCharacter) {
    error = { ...error, especial: 'Su contraseña debe contener al menos un carácter especial' };
  }
  return error;
}

equalsTo(otherField: string) {
  const validator = (formControl: FormControl) => {
    if (otherField == null) {
      throw new Error("Diligencie la información del campo");
    }
    if (!formControl.root || !(<FormGroup>formControl.root).controls) {
      return null;
    }
    const field = (<FormGroup>formControl.root).get(otherField);
    if (!field) {
      throw new Error('Diligencie la información del campo');
    }
    if (field.value !== formControl.value) {
      return { equalsTo: otherField }
    }
    return null;
  };
  return validator;
}
}
